// extracted by mini-css-extract-plugin
module.exports = {"largeBrownBulletsHealth":"LargeBrownBullets_largeBrownBulletsHealth__0cfWY","chakra-collapse":"LargeBrownBullets_chakra-collapse__lp_5f"};